module.exports = __webpack_public_path__ + "assets/img/text2.f54b9369.png";